import { DEBUG } from '@glimmer/env';
import { SafeString } from 'handlebars/dist/handlebars';

import { createLink } from 'rise-ui/utils/dynamic-node/utils/create-link.js';

/**
 * Routing component allows Drupal content to link to other routes in RISE UI.
 */
export function cRoute(...args) {
  const options = args.pop();
  const named = { ...options.hash };
  const defaultAttrs = {
    target: named.external ? '_blank' : null,
  };
  const attrs = [ 'class', 'target' ]
    .map(attr => {
      const value = named[attr] || defaultAttrs[attr];
      return value ? ` ${attr}="${value}"` : ''
    })
    .join('');
  if (DEBUG) {
    if (!args.length) {
      console.error(`Missing \`c-route\` helper route argument.`);
    }
  }
  const link = createLink(args, options, named.id);
  const external = !(link.external || named.external) ? ''
    : '\n<span class="c-external-link__icon">'
    + '<span class="c-icon c-icon--external-link" title="Opens in new window"></span>'
    + '<span class="c-icon__text">Opens in new window</span></span>';
  return new SafeString(`<a href="${link.url}" id="${link.id}"${attrs}>${options.fn(this)}${external}</a>`);
}
